/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertModel } from '@libs/common/models';
import { UserService } from '@libs/shared/services';
import { firstValueFrom, Observable } from 'rxjs';
import { AccountStorage } from '../services';
import { UserDeleteComponent } from './delete';

@Component({
  selector: 'ui-account-delete',
  templateUrl: './account-delete.component.html',
  styleUrls: ['./account-delete.component.scss'],
  imports: [
    MatSnackBarModule,
    UserDeleteComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountDeleteComponent {
  private readonly userService: UserService = inject(UserService);
  private readonly accountStorage: AccountStorage = inject(AccountStorage);

  public hasAccountDeleteNotification$: Observable<boolean | undefined> = this.accountStorage.hasAccountDeleteNotification();
  public alertMessage: AlertModel | undefined;

  private readonly alertMessages: Record<string, AlertModel> = {
    deleteSuccess: {
      theme: 'success',
      message: 'Vielen Dank, Ihr Antrag auf Kontolöschung ist eingegangen und wird schnellstmöglich bearbeitet.',
    },
    deleteError: {
      theme: 'error',
      message: 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut oder wenden Sie sich per E-Mail an <a href="mailto:portal@lekkerland.de">portal@lekkerland.de</a>',
    },
  };

  public onAccountDeleteSubmit(value: string): void {
    this.alertMessage = undefined;
    firstValueFrom(this.userService.deleteUser({ mail: value }))
      .then(() => {
        this.accountStorage.setAccountDeleteNotification();
        this.alertMessage = this.alertMessages['deleteSuccess'];
      })
      .catch(() => {
        this.alertMessage = this.alertMessages['deleteError'];
      });
  }
}
